import { FleekError } from './FleekError';

type TwoFactorSecretKeyFailedToEncryptErrorOptions = Record<string, never>;

export class TwoFactorSecretKeyFailedToEncryptError extends FleekError<TwoFactorSecretKeyFailedToEncryptErrorOptions> {
  public name = 'TwoFactorSecretKeyFailedToEncryptError';

  toString = () => 'Failed to encrypt 2FA secret key.';
}
